import React from 'react';
import { useTranslation } from 'react-i18next';
import './styles.scss';

const Status = ({ status, inline, label }) => {
  const { t } = useTranslation();
  return <div className={'contract_status contract_' + status + (inline ? ' span' : '')}>{label ?? t('contracts.status.' + status)}</div>;
}

export default Status;